import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Values } from "@/components/site/Values";
import { Services } from "@/components/site/Services";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { Team } from "@/components/site/Team";
import { WhyUs } from "@/components/site/WhyUs";
import { Stats } from "@/components/site/Stats";
import { Testimonials } from "@/components/site/Testimonials";
import { AccessibilityBand } from "@/components/site/AccessibilityBand";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-brand-cream">
      <Nav />
      <main id="main">
        <Hero />
        <Values />
        <Services />
        <BeforeAfter />
        <Team />
        <WhyUs />
        <Stats />
        <Testimonials />
        <AccessibilityBand />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}
